import React from "react";
import { FlexBox, Hidden } from "@vp/swan";
import vcsLogo from "../vcs_logo.svg";
import "./VCSFooter.scss";
import { useTranslation } from "../../useTranslation";

const VCSFooter = () => {
  const [t] = useTranslation("app");

  return (
      <Hidden sm xs>
          <FlexBox className='vsc-footer' justifyContent="center" alignItems="center" >
              <img
              data-testid="vsc-logo"
              src={vcsLogo}
              alt={t("vcsLogoAlt")}
            />
          </FlexBox>
      </Hidden>
  );
};

export default VCSFooter;
